import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter } from 'react-router-dom';
import { ThemeProvider } from '@mui/material';
import theme from './theme';
import ResponseHandler from './AxiosWrapper';
import { GoogleOAuthProvider } from '@react-oauth/google';
import { AuthenticationProvider } from './views/dss/AuthenticationProvider';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <BrowserRouter>
    <ThemeProvider theme={theme}>
      <GoogleOAuthProvider clientId='949770729633-t9ogvldm9bffatmus9qnbvfnpf9d0918.apps.googleusercontent.com'>
        <AuthenticationProvider>
          <ResponseHandler>
            <App />
          </ResponseHandler>
        </AuthenticationProvider>
      </GoogleOAuthProvider>
    </ThemeProvider>
  </BrowserRouter>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
